export default __webpack_public_path__ + "images/loggedout/icons/clever_icon-1c250a215a3e9c8f02c4f267f85ccb5b.png";